import {Component, Input} from '@angular/core';
import {UsersService} from '@core/services/users.service';
import {Router} from '@angular/router';
import {ToastComponent} from '../toast/toast.component';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ETipoUsuario, ILogin} from '@core/models';
import {AuthService} from '@core/services/auth.service';
import {AutologinService} from '../../../core/services/autologin.service';
import {
  INotification,
  TypeNotification,
} from '@core/models/INotification.interface';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [ToastComponent],
})
export class LoginComponent {
  @Input() logo: string;
  email: string;
  password: string;

  public formulario: UntypedFormGroup;

  constructor(
    private authService: AuthService,
    private autoLogin: AutologinService,
    public router: Router,
    private toast: ToastComponent,
    private fb: UntypedFormBuilder,
  ) {
    this.formulario = this.fb.group({
      Email: ['', [Validators.required, Validators.email]],
      Password: ['', Validators.required],
    });
  }

  login() {
    if (!this.formulario.valid) {
      this.toast.warningMessage(
        'Error de formulario',
        'Todos los campos son requeridos',
      );
      return;
    }

    this.authService.login(this.formulario.value).subscribe(
      (data: INotification) => {
        if (data.Type === TypeNotification.error) {
          this.toast.errorMessage(
            'Error de login',
            'Usuario o contraseña incorrecta',
          );
          return;
        }

        this.autoLogin.setSession(data.Data);
        this.toast.successMessage('Login exitoso', 'Bienvenido');
        const {TipoUser, Token} = data.Data;
        switch (TipoUser.Id) {
          case ETipoUsuario.ADMINISTRADOR_SISTEMA:
            this.router.navigateByUrl(
              `/system/admin-principal/listadoEmpresas/${Token}`,
            );

            break;
          case ETipoUsuario.ADMINISTRADOR_EMPRESA:
            this.router.navigateByUrl(
              `/system/admin-empresa/configuracionEmpresa/${Token}`,
            );
          case ETipoUsuario.ADMINISTRADOR_INSPECTOR:
            this.router.navigateByUrl(
              `/system/admin-empresa/configuracionEmpresa/${Token}`,
            );

            break;
          case ETipoUsuario.INSPECTOR:
            this.router.navigateByUrl(
              `/system/inspector/listadoDenuncias/${Token}`,
            );

            break;

          default:
            this.router.navigateByUrl(
              `/no-autorizado`,
            );

            break;
            break;
        }
      },
      error => {
        this.toast.errorMessage(
          'Error de login',
          'Usuario o contraseña incorrecta',
        );
        console.log(error);
      },
    );
  }
}
